import { observer } from "mobx-react";
import { useState } from "react";

import FoldableSection from "components/UI/FoldableSection/FoldableSection";
import ActivityList from "./ActivityList/ActivityList";
import MarketItem from "./MarketItem/MarketItem";
import Button from "components/UI/Button/Button";
import Icon from "components/UI/IconSVG/Icon";

import { ENABLED_MARKETS } from "AppStore";

import { getCountPlatforms } from "utils/helpers";

import "./ServicesSection.scss";

const platformCount = ENABLED_MARKETS.length;

const ServicesSection = observer(({ store, isMobile }) => {
  const [animateActivityList, setAnimateActivityList] = useState(false);
  const [selectedActions, setSelectedActions] = useState([]);
  const [expandedSection, setExpandedSection] = useState({
    1: true,
    2: false,
  });

  const handleMarketSelect = (marketId) => {
    setAnimateActivityList(true);
    setSelectedActions([]);
    const fullStoreIndex = store.marketStores.findIndex(
      (marketStore) => marketStore.market.id === marketId,
    );
    if (fullStoreIndex !== -1) {
      store.selectMarketStoreByIndex(fullStoreIndex);
    }
    setTimeout(() => setAnimateActivityList(false), 300);
  };

  const getCurrentSelectedIndex = () => {
    const currentMarketId = store.currentMarketStore?.market?.id;
    return ENABLED_MARKETS.findIndex((market) => market.id === currentMarketId);
  };

  const handleActionSelect = (action) => {
    setSelectedActions((prev) => {
      const exists = prev.find((a) => a.index === action.index);
      return exists
        ? prev.filter((a) => a.index !== action.index)
        : [...prev, action];
    });
  };

  const getPriorityPath = () => {
    if (selectedActions.length === 0) return null;

    const allPaths = store.currentMarketStore.market.mainPageTitles.map(
      (a) => a.path,
    );
    const pathFrequency = allPaths.reduce((acc, path) => {
      acc[path] = (acc[path] || 0) + 1;
      return acc;
    }, {});

    const sorted = [...selectedActions].sort(
      (a, b) => pathFrequency[a.path] - pathFrequency[b.path],
    );
    return sorted[0].path;
  };

  const handleNext = () => {
    const path = getPriorityPath();
    if (path) window.location.href = path;
  };

  const toggleSection = (section) => {
    setExpandedSection((prev) => ({ ...prev, [section]: !prev[section] }));
  };

  return (
    <section className="main__services">
      <div className="main__services_intro">
        <h2 className="main__services_intro-title">Начните проект сейчас</h2>
        <p className="section__text">
          Уже доступно {platformCount} {getCountPlatforms(platformCount)}, но
          будет еще больше!
        </p>
        <div className="main__services_intro-bg-image" />
      </div>
      <div className="main__services_platforms">
        {isMobile ? (
          <>
            <div className="main__services_platforms-markets">
              <FoldableSection
                className={`footer-plate__foldable ${expandedSection[1] ? "expanded" : ""}`}
                expanded={expandedSection[1]}
              >
                <p
                  className={`main__services_platforms-markets-title ${expandedSection[1] ? "expanded" : ""}`}
                  onClick={() => toggleSection(1)}
                >
                  <span>1</span>Выберите площадку
                  <Icon
                    className={`main__services_platforms-markets-icon ${expandedSection[2] ? "expanded" : ""}`}
                    sprite="projects"
                    name="accordion"
                    color="#474747"
                  />
                </p>
                <div className="main__services_platforms-market">
                  {ENABLED_MARKETS.map((market, index) => (
                    <MarketItem
                      key={index.id}
                      market={market}
                      index={index}
                      linkTo={market.modes[0].path}
                      onClick={() => handleMarketSelect(market.id)}
                      isSelected={index === getCurrentSelectedIndex()}
                      isMobile={isMobile}
                      containerClassName="main__services_platforms-items"
                      itemClassName="main__services_platforms-item"
                      logoClassName="main__services_platforms-logo"
                      titleClassName="main__services_platforms-title"
                    />
                  ))}
                </div>
              </FoldableSection>
            </div>
            <div className="main__services_platforms-markets">
              <FoldableSection
                className={`footer-plate__foldable ${expandedSection[2] ? "expanded" : ""}`}
                expanded={expandedSection[2]}
              >
                <p
                  className={`main__services_platforms-markets-title ${expandedSection[2] ? "expanded" : ""}`}
                  onClick={() => toggleSection(2)}
                >
                  <span>2</span>Выберите услугу
                  <Icon
                    className={`main__services_platforms-markets-icon ${expandedSection[2] ? "expanded" : ""}`}
                    sprite="projects"
                    name="accordion"
                    color="#474747"
                  />
                </p>

                <ActivityList
                  store={store}
                  isMobile={isMobile}
                  animate={animateActivityList}
                  selectedActions={selectedActions}
                  onActionSelect={handleActionSelect}
                />
              </FoldableSection>
              {expandedSection[2] && (
                <Button
                  className="main__services_platforms-markets-button-link"
                  title="Далее"
                  onClick={handleNext}
                  disabled={selectedActions.length === 0}
                />
              )}
            </div>
          </>
        ) : (
          <>
            <div className="main__services_platforms-markets">
              <p className="main__services_platforms-markets-title">
                <span>1</span>Выберите площадку
              </p>
              <div className="main__services_platforms-market">
                {ENABLED_MARKETS.map((market, index) => (
                  <MarketItem
                    key={index.id}
                    market={market}
                    index={index}
                    onClick={() => handleMarketSelect(market.id)}
                    isSelected={index === getCurrentSelectedIndex()}
                    isMobile={isMobile}
                    containerClassName="main__services_platforms-items"
                    itemClassName="main__services_platforms-item"
                    logoClassName="main__services_platforms-logo"
                    titleClassName="main__services_platforms-title"
                  />
                ))}
              </div>
            </div>

            <div className="main__services_platforms-markets">
              <p className="main__services_platforms-markets-title">
                <span>2</span>Выберите услугу
              </p>

              <ActivityList
                store={store}
                isMobile={isMobile}
                animate={animateActivityList}
                selectedActions={selectedActions}
                onActionSelect={handleActionSelect}
              />
              <Button
                className="main__services_platforms-markets-button-link"
                title="Далее"
                onClick={handleNext}
                disabled={selectedActions.length === 0}
              />
            </div>
          </>
        )}
      </div>
    </section>
  );
});

export default ServicesSection;
